module.exports = __webpack_public_path__ + "img/diap-4-2.894cc695.png";